/*
  The Light Edit — GA4 event tracking.

  Normally these two events would live in the GTM container (GTM-5VGX7PG), per the
  July 28 build addendum. The container is owned outside the team and access has not
  been granted, so they are sent from the theme instead. Neither event has ever been
  received by GA4, so there is nothing in the container to collide with.

  Move these into GTM and delete this file once container access exists.

  Events:
    blog_product_click  — any shop link carrying ?ref=le-sNN-##-slug
    light_edit_signup   — Klaviyo embedded signup form submit
*/
(function () {
  // GA4 property is configured by the GTM container, not by the theme, so events are
  // scoped to it explicitly. If DebugView shows nothing, drop send_to and the event
  // will go to every configured destination instead.
  var GA4_ID = 'G-LS72S49Y68';
  var SIGNUP_FORM_ID = 'RcpTUt';
  var REF_PREFIX = 'le-s';

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    params = params || {};
    params.send_to = GA4_ID;
    window.gtag('event', name, params);
  }

  function refFrom(url) {
    var match = /[?&]ref=([^&#]*)/.exec(url || '');
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (err) {
      return match[1];
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[href]');
    if (!link) return;

    var ref = refFrom(link.getAttribute('href'));
    if (ref.indexOf(REF_PREFIX) !== 0) return;

    send('blog_product_click', {
      ref: ref,
      link_url: link.href,
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100)
    });
  });

  // Klaviyo embeds dispatch klaviyoForms on window; detail.type is open/submit/close.
  window.addEventListener('klaviyoForms', function (e) {
    var detail = e.detail || {};
    if (detail.type !== 'submit') return;
    if (SIGNUP_FORM_ID && detail.formId !== SIGNUP_FORM_ID) return;

    send('light_edit_signup', { form_id: detail.formId || '' });
  });
})();
